"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = init;
require("./styles.scss");
const calculator_1 = require("./calculator");
const mortgage_calculator_1 = require("./mortgage-calculator");
const debt_service_calculator_1 = require("./debt-service-calculator");
const max_mortgage_calculator_1 = require("./max-mortgage-calculator");
const market_trend_videos_1 = require("./market-trend-videos");
const faqs_1 = require("./faqs");
const research_articles_1 = require("./research-articles");
const mortgage_news_1 = require("./mortgage-news");
const mortgage_glossary_1 = require("./mortgage-glossary");
const educational_videos_1 = require("./educational-videos");
const cockpit_1 = require("./cockpit");
const free_guides_1 = require("./free-guides");
const mortgage_calendar_1 = require("./mortgage-calendar");
function init(initParams) {
    const container = document.getElementById(initParams.containerId);
    if (!container) {
        console.error('Container not found');
        return;
    }
    switch (initParams.product) {
        case "calculator":
            (0, calculator_1.initCalculator)(container);
            break;
        case "mortgage-calculator":
            (0, mortgage_calculator_1.initMortgageCalculator)(container);
            break;
        case "debt-service-calculator":
            (0, debt_service_calculator_1.initDebtServiceCalculator)(container);
            break;
        case "max-mortgage-calculator":
            (0, max_mortgage_calculator_1.initMaxMortgageCalculator)(container);
            break;
        case "cockpit":
            (0, cockpit_1.initCockpit)(container);
            break;
        case "educational-videos":
            (0, educational_videos_1.initEducationalVideos)(container);
            break;
        case "faqs":
            (0, faqs_1.initFaqs)(container);
            break;
        case "free-guides":
            (0, free_guides_1.initFreeGuides)(container);
            break;
        case "market-trend-videos":
            (0, market_trend_videos_1.initMarketTrendVideos)(container);
            break;
        case "mortgage-calender":
            (0, mortgage_calendar_1.initMortgageCalendar)(container);
            break;
        case "mortgage-glossary":
            (0, mortgage_glossary_1.initMortgageGlossary)(container);
            break;
        case "mortgage-news":
            (0, mortgage_news_1.initMortgageNews)(container);
            break;
        case "research-articles":
            (0, research_articles_1.initResearchArticles)(container);
            break;
        default:
            console.error(`Unknown product: ${initParams.product}`);
    }
}
